
import type React from "react"
import { ticketsProps } from "../components/apis/getTickets"
import { closeModalData } from "./DemoPlayApp"
import { pageRoutes } from "../App"
import CreatePatterns, { PatternsData } from "../components/CreatePatterns"
import Timer from "../components/Timer"


interface PurchaseTicketsPageProps {
  drawDetails: any
  onTicketPurchase: () => void
  handleShowModal: (data: closeModalData) => void
  ticketData: ticketsProps | undefined
  setCurrentPage: React.Dispatch<React.SetStateAction<pageRoutes>>
  cutoffTime: Date
  selectTickets: number
  handleTicketCount: (num: number) => void
  handlePlayButton: (status: boolean) => void
  handleAmount: (amount: number) => void
  amount: number
}

const DemoPurchaseTicketPage: React.FC<PurchaseTicketsPageProps> = ({
  drawDetails,
  handleShowModal,
  cutoffTime,
  selectTickets,
  handleTicketCount,
  handlePlayButton,
  handleAmount,
  amount
}) => {
  const drawPatterns: PatternsData = drawDetails && drawDetails.draw.prizes
  const buyTicketHandler = () => {
    const getTicketsPrice = drawDetails ? drawDetails.draw.game.basePrice * selectTickets : 150 * selectTickets
    const getAmount = amount >= getTicketsPrice ? amount - getTicketsPrice : 0

    if (getAmount) {
      handleAmount(Math.round(getAmount))
      handlePlayButton(true)
    } else {
      handleShowModal({ status: true, test: "Insufficient balance. added ₹5000 to your wallet to continue with the demo play.", btnText: "Add" })
    }

  }

  return (
    <div
      className={`relative flex w-full min-h-screen  flex-col  pb-6`}
      style={{
        backgroundImage: `url('/assets/purchaseTicketBg.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Header - Title */}
      <div className="flex w-full justify-center flex-shrink-0 py-2 sm:py-3 md:py-2">
        <img
          src="/assets/selecrCardsText.png"
          alt="select_cards"
          className="w-[150px] sm:w-[180px] md:w-[220px] lg:w-[280px]"
        />
      </div>
      {/* Middle Section - Controls */}
      <div className="w-full h- full flex-shrink-0 mt-2  ">
        <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3 lg:gap-6 md:py-4 lg:py-2">
          <div className="flex h-full   flex-row  items-center justify-center gap-2 md:gap-3  ">

            <div className="flex-shrink-0 h-full">
              <Timer isPurchase drawTime={cutoffTime} />
            </div>

            <div
              className={`relative  flex-shrink-0 bg-contain bg-center bg-no-repeat py-[16px] px-[6px] md:px-[16px]
              flex flex-col items-center justify-center`}
              style={{
                backgroundImage: `url('/assets/numOfTicktBg.png')`,

              }}
            >
              <p className="text-white text-center text-sm sm:text-base font-bold mb-1"
              >NUM CARDS</p>
              <div className="flex justify-around w-full gap-2 px-4 md:px-6">
                {[1, 2, 3, 4].map((num) => {

                  return (
                    <div key={num} className="relative group">
                      <button
                        onClick={() => handleTicketCount(num)}

                        className={`
                        w-8 h-8 lg:w-12 lg:h-12  flex items-center justify-center rounded-sm text-lg font-bold transition-colors text-white
                       ${selectTickets === num ? "bg-blue-500" : "bg-[#321FA5]"} 
                       `}
                      >
                        {num}
                      </button>

                    </div>
                  )
                })}
              </div>
              <span className="text-sm text-white mt-2 font-bold">Price per ticket : ${drawDetails.draw.game.basePrice}</span>
            </div>
          </div>

          <div
            className="
                        md:w-auto md:flex md:justify-center md:mt-0
                        lg:w-auto lg:mt-0
                    "
          >
            <button className="focus:outline-none" onClick={buyTicketHandler} >
              <img
                src="/assets/playBtn.png"
                alt="Play Button"
                className="w-[160px] h-[60px] lg:w-[250px] lg:h-[65px] object-contain"
              />
            </button>
          </div>
        </div>
      </div>

      <div
        className="flex-grow w-full flex justify-center overflow-hidden mt-2 lg:mt-8 "
      >
        <div className="flex justify-center overflow-hidden">
          <CreatePatterns drawPatterns={drawPatterns} />
        </div>
      </div>
    </div>
  )
}

export default DemoPurchaseTicketPage

